export default __webpack_public_path__ + "static/media/crop-full.7b44d0d9.png";